'use strict';
import $ from 'jquery';
import Promise from 'bluebird';
import Cookie from 'js-cookie';
import getToken, {refreshStageFormTokens} from './token';

const BASE_URL = '/fi/api/v1/carts/me/';

/**
 * @param  {String} method
 * @param  {String} url
 * @param  {Object} data
 * @return {Promise}
 */
export const apiCall = (method, url, data = {}) => {
	const promise = method.toLowerCase() !== 'get'
		? getToken()
		: Promise.resolve(false);

	return promise
		.then(token => {
			if (token) data.token = token;
			const xhr = $.ajax({ url, method, data });
			return Promise.resolve(xhr);
		})
		.tap(res => {
			if (res && res.cart && window.localStorage) {
				const id = Cookie.get('cart');
				const data = {
					cart: res.cart,
					id,
					userId: Cookie.get('loggedIn') || '',
					timestamp: new Date().getTime()
				};
				try {
					localStorage.setItem('cart', JSON.stringify(data));
				} catch (e) {
					console.log(e);
				}
			}
		});
}

const isCartInvalidated = data => {
	const cartId = Cookie.get('cart') || '';
	const userId = Cookie.get('loggedIn') || '';

	if ((data.id && data.id !== cartId) || userId !== data.userId) {
		return true;
	}
	const now = new Date();
	if (new Date(data.timestamp) < now.setHours(now.getHours + 1)) {
		return true;
	}
	const expires = data.cart.reservedItems.map(item => item.expires);
	const validUntil = Math.min.apply(Math, expires);
	if (new Date() > new Date(validUntil)) {
		return true;
	}
	return false;
}

/**
 * @return {Promise}
 */
export const getCart = (forceRefresh, params = {}) => {
	let cartData = null;

	if (window.localStorage && !forceRefresh) {
		try {
			cartData = JSON.parse(localStorage.getItem('cart') || null);
		} catch (e) {
			console.log(e);
		}
	}

	if (!cartData) {
		refreshStageFormTokens();
	} else if (cartData && isCartInvalidated(cartData)) {
		localStorage.removeItem('cart');
		cartData = null;
	}

	const cart = cartData
		? { cart: cartData.cart }
		: apiCall('GET', BASE_URL, params);

	return Promise.resolve(cart);
}

export const flushLocalCart = () => {
	try {
		localStorage.removeItem('cart');
	} catch (e) {
		console.log(e);
	}
}

/**
 * @param  {String} itemId
 * @param  {String} subResource
 * @return {String}
 */
const getResourceUrl = (itemId, subResource) => {
	let url = BASE_URL + 'items/';
	if (itemId) url += itemId + '/';
	if (subResource) url += subResource + '/';
	return url;
}

/**
 * @param  {String|Array} ean
 * @param  {Number} amount
 * @param  {String} packageId
 * @return {Promise}
 */
export const addItem = (ean, amount = 1, packageId, additionalInfo = {}, preorder = false) => {
	const eans = Array.isArray(ean) ? ean : [ean];
	const data = { ean: eans, amount, additionalInfo, preorder };
	if (packageId) data.packageId = packageId;
	return apiCall('POST', getResourceUrl(), data);
}

/**
 * @param  {String} itemId
 * @param  {Number} amount
 * @return {Promise}
 */
export const updateItemAmount = (itemId, amount) => {
	return apiCall('PUT', getResourceUrl(itemId), {amount});
}

/**
 * @param  {String} itemId
 * @return {Promise}
 */
export const removeItem = itemId => {
	return apiCall('DELETE', getResourceUrl(itemId));
}

/**
 * @param  {String} itemId
 * @return {Promise}
 */
export const reserveItem = itemId => {
	return apiCall('POST', getResourceUrl(itemId));
}

/**
 * @param  {String} itemId
 * @return {Promise}
 */
export const reserveExpiredItems = () => {
	return apiCall('POST', BASE_URL);
}

/**
 * @return {Promise}
 */
export const removeExpiredItems = () => {
	return apiCall('DELETE', getResourceUrl());
}

/**
 * @param {String} code
 * @return {Promise}
 */
export const applySaleCode = (code, orderId) => {
	return apiCall('POST', BASE_URL + 'salecodes/', {code, orderId});
}

window.cart = {};
window.cart.addItem = addItem;
